'use strict';
module.exports = /^#!.*/;



//////////////////
// WEBPACK FOOTER
// ./~/shebang-regex/index.js
// module id = 3900
// module chunks = 0